import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";
import { TmPagesPicker } from "@/components/company/TmPagesPicker";

export function ManagerAccessDialog({ customerId, user, terminals, onClose }) {
  const [pages, setPages] = useState(user.pages || []);
  const [terminalId, setTerminalId] = useState(user.terminal_id || "");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await api.patch(`/company/${customerId}/users/${user.id}/access`, { pages, terminal_id: terminalId || undefined }); toast.success(`Access updated for ${user.name || user.email}`); onClose(true); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={() => onClose(false)}>
      <DialogContent className="max-w-md" data-testid="manager-access-dialog">
        <DialogHeader><DialogTitle className="font-heading">Terminal manager access — {user.name || user.email}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs">Terminal</Label>
            <Select value={terminalId} onValueChange={setTerminalId}>
              <SelectTrigger data-testid="manager-access-terminal"><SelectValue placeholder="Pick a terminal" /></SelectTrigger>
              <SelectContent>{terminals.map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <TmPagesPicker value={pages} onChange={setPages} testid="manager-access-pages" />
        </div>
        <DialogFooter><Button variant="outline" onClick={() => onClose(false)}>Cancel</Button><Button className="bg-blue-700 hover:bg-blue-800" disabled={busy} onClick={save} data-testid="manager-access-save">Save access</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
